import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API } from "../common/common";
import {
  getBrowser,
  getImageUrl,
  isCaptchaEnabled,
  readCachedAgLoginDesign,
  readCachedLoginImages,
  readLoginFields,
} from "../common/Funcation";
import { canBypassAgMaintenance } from "../common/settingsAccess";
import {
  getLoginPageCssVars,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetColor,
  styleObjectGetLoginImage,
} from "../common/StyleSeter";
import {
  getAppLinkHref,
  getContactChannel,
  getViewAllLinksHref,
  isAppLinkShowing,
  isViewAllLinksShowing,
  normalizeAgLoginDesign,
  normalizeLoginSupportStyle,
} from "../common/loginPage";
import LoginSupportFooter from "../components/LoginSupportFooter";
import SecurityCheck from "../components/SecurityCheck";
import VelkiAgLogin from "./VelkiAgLogin";
import { notifyError, postApi } from "../service";
import instagram from "./../assets/icons/instagram.svg";
import mail from "./../assets/icons/mail.svg";
import skype from "./../assets/icons/skype.svg";
import telegram from "./../assets/icons/telegram.svg";
import whatsapp from "./../assets/icons/whatsapp.svg";
import login from "./../assets/images/login-new.png";
import user from "./../assets/images/usename-4.svg";
import password from "./../assets/images/password-4.svg";

const cookies = new Cookies();
const LOGIN_REQUEST_TIMEOUT_MS = 20000;

const getLoginErrorMessage = (err: any) => {
  const apiMessage = err?.response?.data?.message;
  if (typeof apiMessage === "string" && apiMessage.trim()) {
    return apiMessage;
  }
  if (
    err?.code === "ECONNABORTED" ||
    /timeout/i.test(String(err?.message || ""))
  ) {
    return "Login is taking too long. Please try again.";
  }
  if (!err?.response) {
    return "Unable to connect. Please check your internet and try again.";
  }
  return "Login failed. Please try again.";
};

const Login = () => {
  const [, updateState] = React.useState({});
  const [mobile, setMobile] = React.useState(
    () => typeof window !== "undefined" && window.outerWidth < 577,
  );
  const [contact, setContact] = React.useState("mail");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const DD = useSelector((e: any) => e.domainDetails);
  const domainDetailsLoaded = useSelector((e: any) => e.domainDetailsLoaded);
  const cachedAgLogin = React.useMemo(() => readCachedAgLoginDesign(), []);
  const cachedLoginImages = React.useMemo(() => readCachedLoginImages(), []);
  const agLoginLogo = String(
    DD?.agLoginLogo || cachedLoginImages?.agLoginLogo || "",
  ).trim();
  const loginImagePath =
    agLoginLogo || DD?.loginImage || cachedLoginImages?.loginImage;
  const mobileLoginImagePath =
    agLoginLogo ||
    DD?.mobileLoginImage ||
    cachedLoginImages?.mobileLoginImage ||
    loginImagePath;
  const isCaptcha = isCaptchaEnabled(DD?.captchaAdmin);
  const isB2C = process.env.REACT_APP_B2C;
  // const isB2C = 'false';
  const isDownloadFooter = process.env.REACT_APP_DOWNLOAD_FOOTER;
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    validationCode: "",
  });

  const emailChannel = getContactChannel(DD, "email");
  const whatsappChannel = getContactChannel(DD, "whatsapp");
  const telegramChannel = getContactChannel(DD, "telegram");
  const skypeChannel = getContactChannel(DD, "skype");
  const instagramChannel = getContactChannel(DD, "instagram");

  const getSocialLink = (name: string, values: any) => {
    if (!values || values.length === 0) return "";
    const value = values[0];
    switch (name) {
      case "mail":
        return `mailto:${value}`;
      case "whatsapp":
        return `https://api.whatsapp.com/send?phone=${value}`;
      case "telegram":
        return `https://t.me/${value}`;
      case "skype":
        return `skype:${value}?chat`;
      case "instagram":
        return `https://www.instagram.com/${value}`;
      default:
        return "";
    }
  };

  const SocialIcon = [
    {
      iconStatus: true,
      link: getSocialLink("mail", emailChannel.values),
      image: mail,
      name: "mail",
      values: emailChannel.values,
      showing: emailChannel.showing,
    },
    {
      iconStatus: true,
      link: getSocialLink("whatsapp", whatsappChannel.values),
      image: whatsapp,
      name: "whatsapp",
      values: whatsappChannel.values,
      showing: whatsappChannel.showing,
    },
    {
      iconStatus: true,
      link: getSocialLink("telegram", telegramChannel.values),
      image: telegram,
      name: "telegram",
      values: telegramChannel.values,
      showing: telegramChannel.showing,
    },
    {
      iconStatus: true,
      link: getSocialLink("skype", skypeChannel.values),
      image: skype,
      name: "skype",
      values: skypeChannel.values,
      showing: skypeChannel.showing,
    },
    {
      iconStatus: true,
      link: getSocialLink("instagram", instagramChannel.values),
      image: instagram,
      name: "instagram",
      values: instagramChannel.values,
      showing: instagramChannel.showing,
    },
  ].filter((item) => item.showing && item.link !== "");
  const SocialContact = emailChannel.values;
  const whatsappContact = whatsappChannel.values;
  const Telegram = telegramChannel.values;
  const Skype = skypeChannel.values;
  const Instagram = instagramChannel.values;

  const [confirmationCode, setConfirmationCode] = useState(
    Math.floor(1000 + Math.random() * 9000),
  );
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (DD?.isAgMaintenance === true) {
      navigate("/maintenance", { replace: true });
    }
  }, [DD]);

  useEffect(() => {
    document.body.classList.add("login_screen");
    document.documentElement.classList.add("login_screen");
    handleResize();
    function handleResize() {
      // debugger;
      if (window.outerWidth < 577) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const loginCssVars = getLoginPageCssVars(DD);
  const loginSupportStyle = normalizeLoginSupportStyle(DD?.loginSupportStyle);
  const showAppLink = isAppLinkShowing(DD);
  const showViewAllLinks = isViewAllLinksShowing(DD);
  const hasLoginPageBg = Boolean(loginCssVars["--login-page-bg"]);
  const hasLoginButtonCss = Boolean(
    loginCssVars["--login-button-bg"] || loginCssVars["--login-button-text"],
  );

  useEffect(() => {
    const cssKeys = [
      "--login-page-bg",
      "--login-button-bg",
      "--login-button-text",
      "--login-footer-link-color",
      "--login-support-bg",
      "--login-download-bg",
      "--login-download-text",
    ];
    const nextVars = getLoginPageCssVars(DD);
    if (mobile) {
      Object.entries(nextVars).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value);
      });
    }
    return () => {
      cssKeys.forEach((key) => {
        document.documentElement.style.removeProperty(key);
      });
    };
  }, [DD, mobile]);

  const handelSubmit = async (e: any) => {
    e.preventDefault();
    if (isSubmittingRef.current) {
      return;
    }

    const { username, password } = readLoginFields(e, formData);
    if (username !== formData.username || password !== formData.password) {
      setFormData({ ...formData, username, password });
    }

    let systemDetails = getBrowser();

    if (
      username &&
      password &&
      (confirmationCode === parseInt(formData.validationCode) || !isCaptcha)
    ) {
      setIsValidationWrong(false);
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      try {
        let data = {
          api: ADMIN_API.LOGIN,
          value: {
            user_name: username,
            password,
            browser_detail:
              systemDetails.BrowserName + " V" + systemDetails.BrowserVersion,
            systemDetail: systemDetails.OSname + " V" + systemDetails.OSversion,
            domain: window.location.hostname,
          },
          timeout: LOGIN_REQUEST_TIMEOUT_MS,
        };
        const loginData = await postApi(data);
        const account = loginData?.data?.data;
        if (!account?.token) {
          notifyError("Login failed. Please try again.");
          return;
        }
        let HeaderData = {
          ...account.roleAccess,
          _id: account._id,
          user_name: account.user_name,
          remaining_balance: account.remaining_balance,
          depositeCount: account.depositeCount,
          withdrawaCount: account.withdrawaCount,
        };
        dispatch({ type: "HEADER_DETAILS", payload: HeaderData });
        cookies.set("skyToken", account.token, {
          domain: process.env.REACT_APP_COOKIE_DOMAIN,
          path: "/",
          secure: window.location.protocol === "https:",
          sameSite: "strict",
        });
        dispatch({
          type: "AUTHENTICATION",
          payload: {
            isLogin: true,
            token: account.token,
            changePassword: account.newPassword === true,
          },
        });
        document.body.classList.remove("login_screen");
        document.documentElement.classList.remove("login_screen");
        if (
          DD?.isAgMaintenance &&
          !canBypassAgMaintenance(account.roleAccess?.name)
        ) {
          navigate("/maintenance", { replace: true });
        } else if (account.newPassword === true) {
          navigate("/change/password", { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (err: any) {
        if (
          err?.response?.status === 503 ||
          err?.response?.data?.message === "isAgMaintenance"
        ) {
          navigate("/maintenance");
          return;
        }
        notifyError(getLoginErrorMessage(err));
        setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
        setIsValidationWrong(false);
        setFormData({ ...formData, validationCode: "" });
      } finally {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
      }
    } else {
      Validator.current.showMessages();
      if (!Validator.current.allValid()) {
        notifyError("Please fill in the required fields");
      } else if (
        isCaptcha &&
        confirmationCode !== parseInt(formData.validationCode)
      ) {
        notifyError("Invalid verification code");
      }
      if (isCaptcha && confirmationCode !== parseInt(formData.validationCode)) {
        setIsValidationWrong(true);
      }
      setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    }),
  );

  const downloadFile = () => {
    const imageUrl = `${process.env.REACT_APP_BASE_POINT}admin.apk`;
    // Create a new XMLHttpRequest
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";

    xhr.onload = () => {
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(xhr.response);
      a.download = "admin.apk"; // Set the desired file name
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    xhr.open("GET", imageUrl);
    xhr.send();
  };

  const downloadApp = () => {
    const href = getAppLinkHref(DD);
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };

  const openViewAllLinks = () => {
    const href = getViewAllLinksHref(DD);
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };

  const agLoginDesign = DD?._id
    ? normalizeAgLoginDesign(DD?.agLoginDesign)
    : cachedAgLogin;

  if (agLoginDesign === "velki") {
    return (
      <VelkiAgLogin
        site={{
          ...DD,
          agLoginLogo: DD?.agLoginLogo || cachedLoginImages?.agLoginLogo || "",
        }}
        formData={formData}
        onChange={handelInputChange}
        onSubmit={handelSubmit}
        validator={Validator}
        isSubmitting={isSubmitting}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        isCaptcha={isCaptcha}
        confirmationCode={confirmationCode}
        isValidationWrong={isValidationWrong}
        showAppLink={showAppLink}
        onDownloadApp={downloadApp}
      />
    );
  }

  if (!domainDetailsLoaded && !DD?._id && cachedAgLogin !== "default") {
    return <div className="ag-login-hold" />;
  }

  return !window.location.hostname.includes("msa.") &&
    (!isB2C || isB2C === "false") ? (
    <>
      <Helmet>
        <title>{DD?.title}</title>
      </Helmet>
      {!mobile ? (
        <div
          className="login_main"
          style={styleObjectGetBG(mobile ? DD?.colorSchema : {})}
        >
          <div
            className="login_main_popup"
            style={styleObjectGetBG(DD?.colorSchema)}
          >
            <div
              className="login_popup_image"
              style={styleObjectGetLoginImage(
                mobile ? mobileLoginImagePath : loginImagePath,
              )}
            ></div>
            <div className="login_form_main">
              <h3
                style={styleObjectGetColor(DD?.colorSchema)}
                className="form_title"
              >
                {" "}
                Agent Here{" "}
              </h3>
              <SecurityCheck onSecureSubmit={handelSubmit} onBotDetected={() => notifyError("Security check failed. Please try again.")}>
                {({ honeypotProps, handleSubmit }) => (
                  <form className="login_form" onSubmit={handleSubmit}>
                    <input {...honeypotProps} />
                    <InputGroup
                      name="username"
                      value={formData.username}
                      type="text"
                      onChange={handelInputChange}
                      placeholder="Enter your Username"
                      disabled={isSubmitting}
                      errorValidation={Validator.current.message(
                        "userName",
                        formData.username,
                        "required",
                      )}
                    />
                    <InputGroupPass
                      name="password"
                      value={formData.password}
                      type="password"
                      onChange={handelInputChange}
                      placeholder="Enter your Password"
                      showPass={showPassword}
                      setShowPass={setShowPassword}
                      disabled={isSubmitting}
                      errorValidation={Validator.current.message(
                        "password",
                        formData.password,
                        "required",
                      )}
                    />
                    {isCaptcha && (
                      <div className="validation">
                        <InputGroup
                          name="validationCode"
                          value={formData.validationCode}
                          type="number"
                          onChange={handelInputChange}
                          placeholder="Validation Code"
                          disabled={isSubmitting}
                          errorValidation={Validator.current.message(
                            "validationCode",
                            formData.validationCode,
                            "required",
                          )}
                        />
                        <div
                          style={styleObjectGetColor(DD?.colorSchema)}
                          className="validation_code"
                        >
                          <h3 style={{ lineHeight: "normal" }}>
                            {confirmationCode}
                          </h3>
                        </div>
                      </div>
                    )}
                    {isValidationWrong ? (
                      <span className="error" style={{ color: "red" }}>
                        invalid verification code
                      </span>
                    ) : (
                      ""
                    )}
                    <button
                      type="submit"
                      className={isSubmitting ? "is-loading" : ""}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                    </button>
                  </form>
                )}
              </SecurityCheck>
            </div>
          </div>
          <div className="login_footer">
            {mobile ? (
              <>
                <div className="login_footer_social">
                  {SocialIcon.map((item) => (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className={`social_icon ${contact === item.name ? "active" : ""
                        } `}
                      onClick={() => setContact(item.name)}
                    >
                      <img src={item.image} alt={item.name} />
                    </a>
                  ))}
                </div>
                {/* <div className="login_footer_contact">
                  {contact === "mail" &&
                    SocialContact?.map((item: any) => <span>{item}</span>)}

                  {contact === "whatsapp" &&
                    whatsappContact?.map((item: any) => <span>{item}</span>)}

                  {contact === "telegram" &&
                    Telegram?.map((item: any) => <span> {item}</span>)}

                  {contact === "skype" &&
                    Skype?.map((item: any) => <span> {item}</span>)}

                  {contact === "instagram" &&
                    Instagram?.map((item: any) => <span> {item}</span>)}
                </div> */}
                {isDownloadFooter && (
                  <div className=" footer_power">
                    <h3 id="powerWrapW">
                      <span>Powered by</span>
                      <div className="powerby"></div>
                    </h3>
                    <div className="licence_embed">
                      <a onClick={downloadFile}>
                        <img src="./images/download_app.png" alt="" />
                      </a>
                      <p style={{ marginTop: "5px" }}>
                        v1.07 - 2020-11-11 - 8.2MB
                      </p>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="login_footer_social">
                  {SocialIcon.map((item) => (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className="social_icon"
                    >
                      <img src={item.image} alt={item.name} />
                    </a>
                  ))}
                </div>
                {/* <div className="login_footer_contact">
                  {SocialContact?.map((item: any) => (
                    <span>{item}</span>
                  ))}
                </div> */}
                {isDownloadFooter && (
                  <div className=" footer_power">
                    <h3 id="powerWrapW">
                      <span>Powered by</span>
                      <div className="powerby"></div>
                    </h3>
                    <div className="licence_embed">
                      <a onClick={downloadFile}>
                        <img src="./images/download_app.png" alt="" />
                      </a>
                      <p style={{ marginTop: "5px" }}>
                        v1.07 - 2020-11-11 - 8.2MB
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div
          className={`${window.location.pathname === "/login" ? "login-screen" : ""
            } login_main mobile_screen${hasLoginPageBg ? " backGround" : ""}${loginSupportStyle === "skysupport" ? " is-skysupport" : ""
            }`}
          style={
            {
              ...(hasLoginPageBg ? {} : styleObjectGetBG(DD?.colorSchema)),
              ...loginCssVars,
            } as React.CSSProperties
          }
        >
          <div
            className={`${window.location.pathname === "/login" ? "login-screen" : ""
              } login_main_popup`}
            style={
              hasLoginPageBg ? undefined : styleObjectGetBG(DD?.colorSchema)
            }
          >
            <div
              className="login_popup_image"
              style={styleObjectGetLoginImage(mobileLoginImagePath)}
            ></div>
            <div className="login_form_main">
              {window.location.pathname === "/login" ? (
                <a
                  id="close"
                  className="close"
                  href="/"
                  style={{ display: "none" }}
                ></a>
              ) : (
                <a id="close" className="close" style={{ display: "none" }}></a>
              )}
              {/* <h3 style={styleObjectGetColor(DD?.colorSchema)} className="form_title"> Please login to continue </h3> */}
              <SecurityCheck onSecureSubmit={handelSubmit} onBotDetected={() => notifyError("Security check failed. Please try again.")}>
                {({ honeypotProps, handleSubmit }) => (
                  <form className="login_form" onSubmit={handleSubmit}>
                    <input {...honeypotProps} />
                    <InputGroup
                      name="username"
                      value={formData.username}
                      type="text"
                      onChange={handelInputChange}
                      placeholder="Username"
                      disabled={isSubmitting}
                      errorValidation={Validator.current.message(
                        "userName",
                        formData.username,
                        "required",
                      )}
                    />
                    <InputGroupPass
                      name="password"
                      value={formData.password}
                      type="password"
                      onChange={handelInputChange}
                      placeholder="Enter your Password"
                      showPass={showPassword}
                      setShowPass={setShowPassword}
                      disabled={isSubmitting}
                      errorValidation={Validator.current.message(
                        "password",
                        formData.password,
                        "required",
                      )}
                    />
                    {isCaptcha && (
                      <div className="validation">
                        <InputGroup
                          name="validationCode"
                          value={formData.validationCode}
                          type="number"
                          onChange={handelInputChange}
                          placeholder="Validation Code"
                          disabled={isSubmitting}
                          errorValidation={Validator.current.message(
                            "validationCode",
                            formData.validationCode,
                            "required",
                          )}
                        />
                        <div
                          style={styleObjectGetColor(DD?.colorSchema)}
                          className="validation_code"
                        >
                          <h3 style={{ lineHeight: "normal" }}>
                            {confirmationCode}
                          </h3>
                        </div>
                      </div>
                    )}
                    {isValidationWrong ? (
                      <span className="error" style={{ color: "red" }}>
                        invalid verification code
                      </span>
                    ) : (
                      ""
                    )}
                    <button
                      type="submit"
                      className={isSubmitting ? "is-loading" : ""}
                      disabled={isSubmitting}
                      style={
                        hasLoginButtonCss
                          ? undefined
                          : styleObjectGetBGasColor(DD?.colorSchema)
                      }
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                      <span />
                    </button>
                    {/* {showAppLink && (
                  <>
                    <button
                      type="button"
                      className="login_download_btn login_download_btn--animated"
                      onClick={downloadApp}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0 0 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 0 0 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
                      </svg>
                      <h5>| Download App</h5>
                    </button>
                    <span className="login_download_mark" />
                  </>
                )}
                {showViewAllLinks && (
                  <button
                    type="button"
                    className="login_download_btn login_download_btn--animated"
                    onClick={openViewAllLinks}
                    style={{ height: "40px" }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="25" height="25" viewBox="0 0 512 512" style={{ rotate: "90deg" }}
                    >
                      <g id="XMLID_2_">
                        <path id="XMLID_7_" d="M341.2,0.3c-17,1.7-35.8,10.2-50.3,24.7L233,82.1c-29,29-36.6,75-12.8,98.8l6,6L331,81.2   c6.8-6.8,17-6.8,23.8-0.9l75,75c6.8,6.8,6.8,17-0.9,23.8L324.1,284.8l6,6c23.8,23.8,69,17,98.8-12.8l57.1-57.9   c29-29,34.1-72.4,10.2-96.2l-109-108.2C375.2,3.7,358.2-1.4,341.2,0.3L341.2,0.3z M304.5,159.6c-6.8,0-13.6,2.6-19.6,7.7   L168.3,284.8c-11.1,11.1-11.1,28.1,0,39.2l19.6,19.6c11.1,11.1,28.1,11.1,39.2,0L344.6,226c11.1-11.1,11.1-28.1,0-39.2l-20.4-18.7   C319,162.2,312.2,159.6,304.5,159.6z M147.8,206.4c-21.3-0.9-46.8,8.5-64.7,26.4L26,290.8c-29,29-34.1,72.4-10.2,96.2l109.9,109.9   c23.8,23.8,66.4,18.7,96.2-10.2l57.9-57.1c29-29,36.6-75,12.8-98.8L285,324L180.2,429.6c-6.8,6.8-17,6.8-23.8,0l-75-75   c-6.8-6.8-6.8-17,0-23.8l106.5-103.9l-6-6C172.5,211.6,161.5,207.3,147.8,206.4L147.8,206.4z" />
                      </g>
                    </svg>
                    <h5>| View All Links</h5>
                  </button>
                )} */}
                    {(showAppLink || showViewAllLinks) && (
                      <>
                        <style>
                          {`
                    .login_main .login_main_popup .login_form_main .login_form .login_download_row--pair .login_download_btn svg {
                          left: 5px;
                          width: 22px;
                          height: 22px;
                      }
                    .login_main .login_main_popup .login_form_main .login_form .login_download_row--pair .login_download_btn h5 {
                          font-size: 42px !important;
                      }
                    `}
                        </style>
                        <div
                          className={`login_download_row${showAppLink && showViewAllLinks
                            ? " login_download_row--pair"
                            : ""
                            }`}
                        >
                          {showAppLink && (
                            <button
                              type="button"
                              className="login_download_btn login_download_btn--animated"
                              onClick={downloadApp}
                              style={{ height: "140px" }}
                            >
                              <svg
                                width="87.5"
                                height="87.5"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0 0 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 0 0 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z" />
                              </svg>
                              <h5>| Download App</h5>
                            </button>
                          )}
                          {showViewAllLinks && (
                            <button
                              type="button"
                              className="login_download_btn login_download_btn--animated"
                              onClick={openViewAllLinks}
                              style={{ height: "140px" }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="87.5" height="87.5" viewBox="0 0 512 512" style={{ rotate: "90deg" }}
                              >
                                <g id="XMLID_2_">
                                  <path id="XMLID_7_" d="M341.2,0.3c-17,1.7-35.8,10.2-50.3,24.7L233,82.1c-29,29-36.6,75-12.8,98.8l6,6L331,81.2   c6.8-6.8,17-6.8,23.8-0.9l75,75c6.8,6.8,6.8,17-0.9,23.8L324.1,284.8l6,6c23.8,23.8,69,17,98.8-12.8l57.1-57.9   c29-29,34.1-72.4,10.2-96.2l-109-108.2C375.2,3.7,358.2-1.4,341.2,0.3L341.2,0.3z M304.5,159.6c-6.8,0-13.6,2.6-19.6,7.7   L168.3,284.8c-11.1,11.1-11.1,28.1,0,39.2l19.6,19.6c11.1,11.1,28.1,11.1,39.2,0L344.6,226c11.1-11.1,11.1-28.1,0-39.2l-20.4-18.7   C319,162.2,312.2,159.6,304.5,159.6z M147.8,206.4c-21.3-0.9-46.8,8.5-64.7,26.4L26,290.8c-29,29-34.1,72.4-10.2,96.2l109.9,109.9   c23.8,23.8,66.4,18.7,96.2-10.2l57.9-57.1c29-29,36.6-75,12.8-98.8L285,324L180.2,429.6c-6.8,6.8-17,6.8-23.8,0l-75-75   c-6.8-6.8-6.8-17,0-23.8l106.5-103.9l-6-6C172.5,211.6,161.5,207.3,147.8,206.4L147.8,206.4z" />
                                </g>
                              </svg>
                              <h5>| View All Links</h5>
                            </button>
                          )}
                        </div>
                        <span className="login_download_mark" />
                      </>
                    )}
                  </form>
                )}
              </SecurityCheck>
            </div>
          </div>


          <div style={{ width: "100%", marginTop: "22rem", paddingBottom: "30px" }}>
            <LoginSupportFooter site={DD} />
          </div>
        </div>
      )}
    </>
  ) : (
    <>
      {!isB2C || isB2C === "false" ? (
        <>
          <Helmet>
            <title>{DD?.title}</title>
          </Helmet>
          <div className="login_main velki">
            <main
              className="h-full ml-0 flex-center justify-center bg-no-repeat bg-cover"
              style={{ minWidth: "100%" }}
            >
              <div className="form-size rounded-xl sm:flex justify-center items-center divide-x-0 sm:divide-x divide-white divide-opacity-30">
                <div className="logo-theme"></div>
                <div className="w-60 space-y-3 sm:pl-7">
                  <h3 className="lg-title text-white text-center">
                    <span className="text-3xl mr-2">Agent</span>Sign in
                  </h3>
                  {/* <form className='login_form' onSubmit={(e) => handelSubmit(e)}>
                                <InputGroup name='username' value={formData.username} type='text' onChange={handelInputChange} placeholder='Enter your Username' errorValidation={Validator.current.message('userName', formData.username, 'required')} />
                                <InputGroupPass name='password' value={formData.password} type="password" onChange={handelInputChange} placeholder='Enter your Password' showPass={showPassword} setShowPass={setShowPassword} errorValidation={Validator.current.message('password', formData.password, 'required')} />
                                {isCaptcha !== "false" && <div className='validation'>
                                    <InputGroup name='validationCode' value={formData.validationCode} type="text" onChange={handelInputChange} placeholder='Validation Code' errorValidation={Validator.current.message('validationCode', formData.validationCode, 'required')} />
                                    <div style={styleObjectGetColor(DD?.colorSchema)} className='validation_code'><h3>{confirmationCode}</h3></div>
                                </div>}
                                {isValidationWrong ? <span className="error" style={{ color: 'red' }}>invalid verification code</span> : ''}
                                <button type='submit' onSubmit={(e) => handelSubmit(e)}>Login</button>
                            </form> */}

                  <input
                    className="h-10 leading-10"
                    type="text"
                    name={"username"}
                    value={formData.username}
                    onChange={(e) => handelInputChange(e)}
                    placeholder="Enter your Username"
                    disabled={isSubmitting}
                  />
                  {Validator.current.message(
                    "userName",
                    formData.username,
                    "required",
                  ) ? (
                    <span className="error" style={{ color: "red" }}>
                      {Validator.current.message(
                        "userName",
                        formData.username,
                        "required",
                      )}
                    </span>
                  ) : (
                    ""
                  )}

                  <input
                    className="h-10 leading-10"
                    type="password"
                    name={"password"}
                    value={formData.password}
                    onChange={(e) => handelInputChange(e)}
                    placeholder="Enter your Password"
                    disabled={isSubmitting}
                  />
                  {Validator.current.message(
                    "password",
                    formData.password,
                    "required",
                  ) ? (
                    <span className="error" style={{ color: "red" }}>
                      {Validator.current.message(
                        "password",
                        formData.password,
                        "required",
                      )}
                    </span>
                  ) : (
                    ""
                  )}

                  {isCaptcha && (
                    <>
                      <div className="relative">
                        <input
                          className="h-10 leading-10"
                          type="number"
                          name={"validationCode"}
                          value={formData.validationCode}
                          onChange={(e) => handelInputChange(e)}
                          placeholder="Validation Code"
                          disabled={isSubmitting}
                        />
                        <h3 className="absolute right-1 top-3 w-1/3">
                          {confirmationCode}
                        </h3>
                        <input
                          id="valid"
                          name="valid"
                          type="hidden"
                          value="6876b222-2014-45a9-a562-28e98688fb7f"
                        />
                      </div>
                      {Validator.current.message(
                        "validationCode",
                        formData.validationCode,
                        "required",
                      ) ? (
                        <p
                          className="text-red-600 text-center sm:text-left"
                          style={{ color: "red", marginTop: "0" }}
                        >
                          {Validator.current.message(
                            "validationCode",
                            formData.validationCode,
                            "required",
                          )}
                        </p>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  <a
                    onClick={(e) => handelSubmit(e)}
                    id="loginBtn"
                    aria-disabled={isSubmitting}
                    className={`loginBtn btn btn-highlight w-full rounded-sm h-10 leading-10 text-black px-3 space-x-2${isSubmitting ? " is-loading" : ""}`}
                  >
                    <span className="text-base">
                      {isSubmitting ? "Logging in..." : "Login"}
                    </span>
                    {!isSubmitting && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        ></path>
                      </svg>
                    )}
                  </a>
                </div>
              </div>
            </main>
          </div>
        </>
      ) : (
        <>
          <Helmet>
            <title>{DD?.title}</title>
          </Helmet>
          <div className="login-form">
            <div
              className="login-img"
              style={{
                background: `url(${login})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              {/* <img src={login} alt="Login" /> */}
            </div>
            <div className="form-info">
              <form action="" onSubmit={(e) => handelSubmit(e)}>
                <div className="logo-img">
                  <img src={getImageUrl(agLoginLogo || DD?.logo)} alt="logo" />
                </div>
                <h5>Welcome To Admin Login</h5>
                <div className="form-group">
                  <label htmlFor="">Username</label>
                  <div className="icon-input">
                    <input
                      className="h-10 leading-10"
                      type="text"
                      name={"username"}
                      value={formData.username}
                      onChange={(e) => handelInputChange(e)}
                      placeholder="Username"
                      disabled={isSubmitting}
                    />
                    <img src={user} alt="User" />
                  </div>
                  {Validator.current.message(
                    "userName",
                    formData.username,
                    "required",
                  ) ? (
                    <span className="error" style={{ color: "red" }}>
                      {Validator.current.message(
                        "userName",
                        formData.username,
                        "required",
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="">Password</label>
                  <div className="icon-input">
                    <input
                      className="h-10 leading-10"
                      type="password"
                      name={"password"}
                      value={formData.password}
                      onChange={(e) => handelInputChange(e)}
                      placeholder="Enter your Password"
                      disabled={isSubmitting}
                    />
                    <img src={password} alt="User" />
                  </div>
                  {Validator.current.message(
                    "password",
                    formData.password,
                    "required",
                  ) ? (
                    <span className="error" style={{ color: "red" }}>
                      {Validator.current.message(
                        "password",
                        formData.password,
                        "required",
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group">
                  <a
                    onClick={(e) => handelSubmit(e)}
                    id="loginBtn"
                    aria-disabled={isSubmitting}
                    className={`loginBtn btn btn-highlight w-full rounded-sm h-10 leading-10 text-black px-3 space-x-2${isSubmitting ? " is-loading" : ""}`}
                  >
                    {isSubmitting ? "Logging in..." : "Login"}
                    {!isSubmitting && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        ></path>
                      </svg>
                    )}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Login;

export const InputGroup = (props: any) => {
  const {
    type,
    placeholder,
    name,
    value,
    onChange,
    errorValidation,
    disabled,
  } = props;
  return (
    <div className="input_group">
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        disabled={disabled}
      />
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};
export const InputGroupPass = (props: any) => {
  const {
    type,
    placeholder,
    name,
    value,
    onChange,
    errorValidation,
    showPass,
    setShowPass,
    disabled,
  } = props;
  return (
    <div className="input_group">
      <div style={{ position: "relative" }}>
        <input
          type={showPass ? "text" : type}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          placeholder={placeholder}
          disabled={disabled}
        />
        <span
          onClick={() => setShowPass(!showPass)}
          style={{
            position: "absolute",
            right: "5px",
            top: "50%",
            transform: "translate(0, -50%)",
          }}
        >
          <img
            src={showPass ? "./images/eye_close.png" : "./images/eye.png"}
            alt=""
          />
        </span>
      </div>
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

// const Login = () => {

//     useEffect(() => {
//         document.body.classList.add('login_screen');
//         document.documentElement.classList.add('login_screen')
//     }, [])
// return (
//     <>
//         <div className='login_main velki'>
//             <main className="h-full ml-0 flex-center justify-center bg-no-repeat bg-cover" style={{ minWidth: "100%" }}>
//                 <div className="rounded-xl sm:flex justify-center items-center divide-x-0 sm:divide-x divide-white divide-opacity-30">
//                     <div className="logo-theme"></div>
//                     <div className="w-60 space-y-3 sm:pl-7">
//                         <h3 className="lg-title text-white text-center"><span className="text-3xl mr-2">Agent</span>Sign in</h3>
//                         <input className="h-10 leading-10" type="email" placeholder="Username" id="loginName" />
//                         <input className="h-10 leading-10" type="password" placeholder="Password" id="password" />
//                         <div className="relative">

//                             <input type="text" id="validCode" pattern="[0-9]*" data-role="none" className="h-10 leading-10" placeholder="Validation Code" autoComplete="off" inputMode="numeric" maxLength={4} />
//                             <img id="authenticateImage" src="https://msa.velkiex123.live/verifycode.gr?v=1710775362157" className="absolute right-1 top-3 w-1/3" />
//                             <input id="valid" name="valid" type="hidden" value="6876b222-2014-45a9-a562-28e98688fb7f" />
//                         </div>

//                         <a href="#" id="loginBtn" className="loginBtn btn btn-highlight w-full rounded-sm h-10 leading-10 text-black px-3 space-x-2">
//                             <span className="text-base">Login</span>
//                             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
//                             </svg>
//                         </a>

//                         <p id="errorMsg" className="text-red-600 text-center sm:text-left" style={{ display: "none" }}></p>
//                     </div>
//                 </div>
//             </main>
//         </div>
//     </>
// )
// }

// export default Login
